"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var onElementReady = function onElementReady($element) {
  return new Promise(function (resolve) {
    var waitForElement = function waitForElement() {
      if ($element) {
        resolve($element);
      } else {
        window.requestAnimationFrame(waitForElement);
      }
    };
    waitForElement();
  });
};

exports.default = onElementReady;